import React, { useContext } from 'react';
import { Tooltip } from '@material-ui/core'
import ScreenTextContext from '../contexts/ScreenTextContext';

// Displays category graphics for the categories selected in set up along with a header
export const SelectedCategories = ({categories}) => {

  const { screenText } = useContext(ScreenTextContext);  

  if (!screenText || !screenText.global ) {
    return ''; // Should return error? Loading?
  }

  return (
    <div className="selected-categories">
      
      <h2 className="selected-categories__title">{screenText.global.selectedCategories}</h2>
      
      {categories.sort().map(c => (
      
        <Tooltip key={c} title={screenText.global.categories[c]}>
      
          <img src={`${process.env.PUBLIC_URL}/assets/images/categories/${c}-active.png`} alt={screenText.global.categories[c]} />
      
        </Tooltip>
        
      ))}

    </div>
  )
}